import React, { FunctionComponent } from 'react';
import { Column, Row } from '@iag-packages/chroma-react/lib/layouts';
import Media from 'react-media';

import { LoaderModal } from 'components';
import { FooterBottom } from 'scenes/common/components/Footer';
import { HeaderTop } from 'scenes/common/components/Header';
import { SCREEN } from 'scenes/common/types/screen';
import { ProgressBarFlow } from 'scenes/common/types';
import { isStopFunnels } from 'shared/config';
import {
  FooterContainer,
  FullPageContainer,
  FullPageRoot,
  FullPageRow,
  MobilePaddingContainer,
  SidebarColumn,
  StyledContainer,
  UpperContainer,
} from './FullPageWrapper.styles';

interface FullPageWrapperProps {
  isLoading: boolean;
  Header?: FunctionComponent;
  Sidebar?: FunctionComponent;
  Footer?: FunctionComponent;
  progress?: number;
  showProgressBar?: boolean;
  ProgressBarIcon?: FunctionComponent;
  ProgressFlowBar?: FunctionComponent;
  onClickCallUs: () => void;
  currentProgressBarFlow?: ProgressBarFlow;
  shouldSkipHardcodedHeadingColor?: boolean;
  awardsToDisplay?: Array<FunctionComponent>;
  disclaimersToDisplay?: Array<FunctionComponent>;
  MotorProgressBar?: JSX.Element;
  motorExperimentalStyles?: boolean;
}

const FullPageWrapper: FunctionComponent<FullPageWrapperProps> = ({
  ...props
}) => {
  const {
    progress,
    showProgressBar,
    Header,
    Sidebar,
    Footer,
    isLoading,
    ProgressBarIcon,
    ProgressFlowBar: ProgressBar,
    children,
    onClickCallUs,
    currentProgressBarFlow,
    shouldSkipHardcodedHeadingColor,
    disclaimersToDisplay,
    MotorProgressBar,
    motorExperimentalStyles,
  } = props;
  return (
    <FullPageRoot
      shouldSkipHardcodedHeadingColor={shouldSkipHardcodedHeadingColor}
    >
      <FullPageContainer>
        <FullPageRow
          displaySidebar={!!Sidebar}
          motorExperimentalStyles={motorExperimentalStyles}
        >
          <Media query={{ minWidth: SCREEN.LARGE }}>
            {(isLargeScreen) => {
              const showSidebar = Sidebar && isLargeScreen;

              return (
                <>
                  <Column xs={showSidebar ? 9 : 12}>
                    <UpperContainer>
                      <div>
                        <HeaderTop
                          progress={progress}
                          showProgressBar={showProgressBar}
                          ProgressBarIcon={ProgressBarIcon}
                          ProgressFlowBar={ProgressBar}
                          onClickCallUs={onClickCallUs}
                          currentProgressBarFlow={currentProgressBarFlow}
                          MotorProgressBar={MotorProgressBar}
                          motorExperimentalStyles={motorExperimentalStyles}
                        />
                        <div role="banner">{Header && <Header />}</div>
                        <MobilePaddingContainer role="main">
                          <StyledContainer>
                            <Row>
                              <Column xs={12} md={6} mdOffset={3}>
                                <>{children}</>
                              </Column>
                            </Row>
                          </StyledContainer>
                        </MobilePaddingContainer>
                      </div>
                      <FooterContainer>
                        {Footer && <Footer />}
                        {!isStopFunnels() && (
                          <FooterBottom disclaimers={disclaimersToDisplay} />
                        )}
                      </FooterContainer>
                    </UpperContainer>
                  </Column>
                  {Sidebar && isLargeScreen && (
                    <SidebarColumn lg={3}>
                      <div role="region">
                        <Sidebar />
                      </div>
                    </SidebarColumn>
                  )}
                </>
              );
            }}
          </Media>
        </FullPageRow>
      </FullPageContainer>
      <LoaderModal isOpen={isLoading} />
    </FullPageRoot>
  );
};

export default FullPageWrapper;
